export default [
  {
    path: '/app/studio',
    name: 'Studio',
    component: () => import('@/views/Admin/Studio/Index.vue'),
    meta: {
      pageTitle: 'Stüdyo',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_STUDIO_LIST',
      action: 'read',
    },
  },

]
